export const setUserInfo = (state, data) => {
  state.userInfo = data;
};
export const setStbNumber = (state, data) => {
  state.boxNumber = data;
};
export const setItemsInfoCart = (state, data) => {
  state.getCartDetails = data;
};
export const setSurveyPageNum = (state, page) => {
  state.pageNum = page;
};
export const setSurveyQuestions = (state, question) => {
  if(question && question.length){
    state.surveyQuestions = [...state.surveyQuestions, ...question]
  }else{
    state.surveyQuestions = []
  }
};
export const setImage = (state, data) => {
  console.log("setImage", data);
  state.docImage = data;
};
export const setCartDataDetails = (state, data) => {
  state.cartData = data
};
export const setCTAImages= (state, data) => {
  state.CTAImages = data;
};
export const setCartDetails= (state, data) => {
  state.CartDetails = data;
};
export const setBBDetails= (state, data) => {
  state.bbDetails = data;
};


// WEBPACK FOOTER //
// ./src/store/mutations.js